import { memo } from "react";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";
import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { MagazineAnalyticsSettingFormModel } from "../../model/type";
import type { MagazineAnalyticsSettingFormModelMethodsType } from "../../model/use-case/use-create-model/methods";

type Props = {
	viewModel: MagazineAnalyticsSettingFormModel["ViewModel"];

	onSetGtmAvailable: MagazineAnalyticsSettingFormModelMethodsType["magazineAnalyticsSettingFormModelMethods"]["onSetGtmAvailable"];
	onSetGtmID: MagazineAnalyticsSettingFormModelMethodsType["magazineAnalyticsSettingFormModelMethods"]["onSetGtmID"];
};

export const DesignMagazineAnalyticsSettingGTMIsland = memo(({ viewModel, onSetGtmAvailable, onSetGtmID }: Props) => {
	const { gtmAvailable, gtmID } = viewModel;

	return (
		<FeatureIslandMainWithBackGround islandTitle="Google Analytics設定">
			<QuestionForMain
				required={false}
				title={"Google Analyticsの設定"}
				guide="CHILLNNではGTM(Google Tag Manager)を利用して、サイトのアクセス解析を行うことができます。<br />
					GTMから始まる（「GTM-XXXXXXX」）コンテナIDを取得してください。この設定はいつでも変更できます。"
				inputChildren={
					<>
						<CheckboxField
							value={gtmAvailable.value}
							errorMessage={gtmAvailable.error}
							label={"Google Analyticsを設定する"}
							handleChange={onSetGtmAvailable}
						/>
						{gtmAvailable.value && (
							<InputTextField
								className="w-full xl:w-2/3"
								value={gtmID?.value}
								label="GTMのコンテナIDを入力してください。（ex.「GTM-XXXXXXX」）"
								errorMessage={gtmID?.error}
								handleChange={onSetGtmID}
							/>
						)}
					</>
				}
			/>
		</FeatureIslandMainWithBackGround>
	);
});

DesignMagazineAnalyticsSettingGTMIsland.displayName = "DesignMagazineAnalyticsSettingGTMIsland";
